export default __webpack_public_path__ + "static/media/858.5c12574b.png";